import Contact from './pages/Contact/Contact';
import React from "react";
import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./pages/Home/Home";
import Farms from "./pages/Farm/Farms";
import About from "./pages/About/About";
// import Invoice from "./pages/InvoicePage/Invoice";
import PlotLayoutPage from "./pages/Plot/Plot";
// import AdminLogin from "../src/pages/admin/AdminLogin";
// import AdminDashboard from "../src/pages/admin/AdminDashboard";
// import ProtectedRoute from "./components/ProtectedRoute";
import Kookal from './pages/Kookal/Kookal';

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path='/contact' element={<Contact/>}/>
          <Route path="/form" element={<Farms />} />
          <Route path="/about" element={<About />} />
          {/* <Route path="/invoice" element={<Invoice />} /> */}
          <Route path="/plot" element={<PlotLayoutPage />} />
          {/* <Route path="/admin/login" element={<AdminLogin />} /> */}
        {/* <Route
          path="/admin/dashboard"
          element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          }
        /> */}
          <Route path="/kookal" element={<Kookal />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
